<template>
  <div class="viewport-list-box">
    <div
      class="list-box"
      v-if="viewportList.length">
      <div
        class="list-item-box"
        v-for="(item, index) in viewportList"
        :key="index">
        <div class="name-box">
          <div
            v-if="
              item.isDefault &&
              isChecked('Project.Single.SceneViewPort.Operate')
            "
            class="default-viewport-box">
            主视口
          </div>
          <div
            class="text-overflow"
            :title="item.name">
            {{ item.name }}
          </div>
        </div>
        <div
          class="img-box"
          @click="handleImgItemClick(item)">
          <img :src="getImgSrc(item)" />
        </div>
        <div class="bottom-box">
          <div class="time-box">
            {{ formatTime(item.creationTime) }}
          </div>
          <div class="btn-box">
            <el-button
              v-if="isChecked('Project.Single.SceneViewPort.Operate')"
              type="text"
              size="small"
              title="设置为主视口"
              @click.stop="setDefaultViewport(item)">
              <icon-svg icon-class="icon-zhushitu" />
            </el-button>
            <el-button
              type="text"
              size="small"
              title="视口详情"
              @click.stop="openViewportDetailsPanel(item)">
              <icon-svg icon-class="icon-xinxi" />
            </el-button>
            <el-button
              v-if="isChecked('Project.Single.SceneViewPort.Operate')"
              type="text"
              size="small"
              title="编辑视口"
              @click.stop="editViewport(item)">
              <icon-svg icon-class="icon-bianji" />
            </el-button>
            <el-button
              v-if="isChecked('Project.Single.SceneViewPort.Operate')"
              type="text"
              size="small"
              title="更换视口快照"
              @click.stop="updateViewportImg(item)">
              <icon-svg icon-class="icon-shuaxinshikou" />
            </el-button>
            <el-button
              v-if="isChecked('Project.Single.SceneViewPort.Operate')"
              type="text"
              size="small"
              title="删除"
              @click.stop="deleteViewport(item)">
              <icon-svg icon-class="icon-shanchushikou" />
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="empty-box"
      v-else>
      <div class="tip-box">
        <div class="img-box">
          <img :src="require('@/assets/img/no-params.png')" />
        </div>
        <div
          class="text-box"
          v-if="isChecked('Project.Single.SceneViewPort.Operate')">
          <span>暂无视口，您可以点击</span>
          <span class="bold-text-box">新建视口</span>
          <span>创建</span>
        </div>
        <div
          v-else
          class="text-box">
          暂无视口
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatTime } from '@/utils/generalMethods'

import { Store } from '@/utils/store'

import {
  getSceneViewportDetailsService,
  setViewAngleService,
  deleteSceneViewportService,
  updateSceneViewportImgService,
  setSceneViewportDefaultService
} from '@/service/interface.js'

export default {
  data() {
    return {}
  },
  props: {
    viewportList: Array,
    refreshViewportList: Function
  },
  methods: {
    handleImgItemClick(viewportInfo) {
      let visualAngle = JSON.parse(viewportInfo.visualAngle)

      let camLoc = new window.BlackHole3D.RECamLoc()
      camLoc.camPos = visualAngle.camPos
      camLoc.camRotate = visualAngle.camRotate
      window.BlackHole3D.Camera.setCamLocateTo(camLoc, 0.5, 1)
    },
    openViewportDetailsPanel(viewportInfo) {
      this.queryViewportDetails(viewportInfo).then(viewporDetails => {
        this.$emit('openViewportDetailsPanel', viewporDetails)
      })
    },
    setDefaultViewport(viewportInfo) {
      if (viewportInfo.isDefault) {
        this.$message.warning('当前视口已经是主视口')
        return
      }

      this.$confirm('您确定将当前视口设置为主视口吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.setViewAngleRequest(viewportInfo.visualAngle).then(() => {
          let viewportId = viewportInfo.sceneViewPortId
          let camLoc = JSON.parse(viewportInfo.visualAngle)
          this.setCamForcedLoc(camLoc)
          setSceneViewportDefaultService(viewportId).then(response => {
            if (response.isSuccess) {
              this.refreshViewportList().then(() => {
                this.$message.success('主视图设置成功')
              })
            } else {
              this.$message.error(response.errMsg)
            }
          })
        })
      })
    },
    editViewport(viewportInfo) {
      this.$emit('openViewportDialog', viewportInfo)
    },
    updateViewportImg(viewportInfo) {
      this.$confirm('您确定要更新当前视口快照吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.createViewportImg().then(imgSrc => {
          let visualAngle = this.getViewAngle()
          let base64Image = imgSrc.replace('data:image/png;base64,', '')
          let params = {
            sceneViewPortId: viewportInfo.sceneViewPortId,
            base64Image,
            visualAngle
          }
          updateSceneViewportImgService(params).then(response => {
            if (response.isSuccess) {
              if (viewportInfo.isDefault) {
                this.setViewAngleRequest(visualAngle).then(() => {
                  this.refreshViewportList().then(() => {
                    this.$message.success('更新成功')
                  })
                })
              } else {
                this.refreshViewportList().then(() => {
                  this.$message.success('更新成功')
                })
              }
            } else {
              this.$message.error(response.errMsg)
            }
          })
        })
      })
    },
    deleteViewport(viewportInfo) {
      this.$confirm('此操作将永久删除该视口，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteSceneViewportService(viewportInfo.sceneViewPortId).then(
          response => {
            if (response.isSuccess) {
              this.refreshViewportList().then(() => {
                this.$message.success('删除成功！')
              })
            } else {
              this.$message.error(response.errMsg)
            }
          }
        )
      })
    },
    async createViewportImg() {
      const BlackHole3D = window.BlackHole3D
      BlackHole3D.Graphics.setGeoCoordVisible(false)
      BlackHole3D.Graphics.setViewCubeVisible(false)
      BlackHole3D.Graphics.setSysUIPanelVisible(false)

      await this.sleep(100)

      let imgSrc = BlackHole3D.getScreenSnapshot()
      BlackHole3D.Graphics.setGeoCoordVisible(true)
      BlackHole3D.Graphics.setViewCubeVisible(true)
      BlackHole3D.Graphics.setSysUIPanelVisible(true)

      return imgSrc
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    getViewAngle() {
      let camLocate = window.BlackHole3D.Camera.getCamLocate()
      let { camDir, camPos, camRotate } = camLocate
      camDir = camDir.map(el => Number(el.toFixed(6)))
      camPos = camPos.map(el => Number(el.toFixed(6)))
      camRotate = camRotate.map(el => Number(el.toFixed(6)))
      let visualAngleObj = { camDir, camPos, camRotate }
      let visualAngle = JSON.stringify(visualAngleObj)

      return visualAngle
    },
    getImgSrc(viewportInfo) {
      let timestamp = new Date().getTime()
      let imgSrc = `${window.imageBaseUrl}/${viewportInfo.thumbnail}?timestamp=${timestamp}`
      return imgSrc
    },
    setViewAngleRequest(visualAngle) {
      return new Promise(resolve => {
        let projId = this.$route.params.projId
        let resourceId = this.$route.query.sceneId
        let params = {
          projId,
          resourceId,
          definedType: 2,
          visualAngle
        }
        setViewAngleService(params).then(response => {
          if (response.isSuccess) {
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    setCamForcedLoc(camLoc) {
      const BlackHole3D = window.BlackHole3D

      let cameraLoc = new BlackHole3D.RECamLoc()
      cameraLoc.camPos = camLoc.camPos
      cameraLoc.camRotate = camLoc.camRotate
      BlackHole3D.Camera.setCamLocateTo(cameraLoc, 0.5, 1)

      let forceCamLoc = new BlackHole3D.REForceCamLoc()
      forceCamLoc.force = true
      forceCamLoc.camPos = camLoc.camPos
      forceCamLoc.camRotate = camLoc.camRotate
      BlackHole3D.Camera.setCamForcedInitLoc(forceCamLoc)
    },
    queryViewportDetails(viewportInfo) {
      return new Promise(resolve => {
        let viewportId = viewportInfo.sceneViewPortId
        getSceneViewportDetailsService(viewportId).then(response => {
          if (response.isSuccess) {
            let data = response.data
            resolve(data)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    formatTime
  }
}
</script>

<style lang="less" scoped>
.viewport-list-box {
  flex-grow: 1;
  overflow: hidden;

  .list-box {
    height: calc(100% - 8px);
    margin-top: 8px;
    overflow-y: auto;

    .list-item-box {
      margin-bottom: 8px;
      padding: 8px;
      border-radius: 8px;
      border: 1px solid var(--viewport-list-border-color);

      &:last-child {
        margin-bottom: 0;
      }

      .name-box {
        display: flex;
        align-items: center;
        font-size: 14px;
        text-align: left;

        .default-viewport-box {
          flex-shrink: 0;
          margin-right: 5px;
          font-size: 12px;
          padding: 0px 4px;
          color: var(--base-dark35-color);
          border-radius: 4px;
          border: 1px solid var(--base-dark35-color);
          background: var(--base-bg-light-color75);
        }
      }

      .img-box {
        margin: 4px 0px;
        height: 176px;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
          border-radius: 6px;
          object-fit: cover;
        }
      }

      .bottom-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 4px;

        .time-box {
          font-weight: 400;
          font-size: 14px;
          color: var(--viewport-text-color);
        }

        .btn-box {
          .el-button--text {
            margin-left: 0px;
            color: var(--viewport-btn-text-color);
            padding: 2px;

            &:hover {
              color: var(--base-primary-bgColor);
              background: var(--base-bg-light-color77);
            }
          }
        }
      }
    }
  }

  .empty-box {
    display: flex;
    height: 100%;

    .tip-box {
      margin: auto;
      font-size: 12px;
      color: var(--viewport-btn-empty-text-color);

      .text-box {
        width: 200px;
        margin: auto;
        line-height: 22px;
      }

      .bold-text-box {
        font-weight: bold;
        color: var(--viewport-btn-empty-bold-text-color);
      }
    }
  }
}
</style>
